import img1 from "../assets/images/havelock.webp";
import img2 from "../assets/images/neil-island.webp";
import img3 from "../assets/images/wild.webp";
import img4 from "../assets/images/mogali.webp";
import hero4 from "../assets/images/baratang.webp";
import hero5 from "../assets/images/ross-island.webp";
import hero6 from "../assets/images/kashmir.webp";
import hero7 from "../assets/images/heros1.webp";

import "../assets/css/Gallery.css";

function GallerySection() {
  const gallery = [
    { img: img1, title: "Tadoba Safari", tag: "Wildlife" },
    { img: img2, title: "Kashmir Tour", tag: "Adventure" },
    { img: img3, title: "Mogli Camp", tag: "Kids Camp" },
    { img: img4, title: "Char Dham", tag: "Spiritual" },
    { img: hero4, title: "Jungle Life", tag: "Nature" },
    { img: hero5, title: "Summer Camp", tag: "Fun" },
    { img: hero6, title: "Tulip Garden", tag: "Travel" },
    { img: hero7, title: "Mountains", tag: "Explore" },
  ];

  return (
    <div className="gallery-section">
      <div className="gallery-title text-center mt-5 mb-5">
        <span className="gallery-subtitle">Explore Moments</span>
        <h2>Gypsy Gallery</h2>
        <div className="title-line"></div>
      </div>

      <div className="gallery-grid">
        {gallery.map((item, index) => (
          <div className="gallery-card" key={index}>
            <img src={item.img} alt={item.title} />

            <div className="gallery-overlay">
              <h3>{item.title}</h3>
              <p>{item.tag}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GallerySection;